<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
   <pb-body-base :busy="busy">
      <template v-slot:default="props">
         <pb-body>
            <template slot="title">
               <b-container>
                  <b-row class="mt-7 mb-4">
                  </b-row>
               </b-container>
            </template>
            <template slot="body">
               <b-container>
                  <b-row>
                     <b-col class="p-0 m-0">
                        <b-row>
                           <b-col :class="{ 'disabled-column': item.disableForGuests }" class="mt-4" :md="item.width"
                                  v-bind:key="index" v-for="(item, index) in layout">

                              <div class="content-wrapper"><h2 v-if="item.template === 'Headline'">{{
                                    item.headline
                                 }}</h2>
                                 <div class="about-box"
                                      v-else-if="item.template === 'Vertikal Bild und Text'">
                                    <b-row no-gutters v-if="item.image">
                                       <b-col>
                                          <img :src="fileResourceUrl(item.image)"
                                               :alt="item.image"/>
                                       </b-col>
                                    </b-row>
                                    <b-row no-gutters>
                                       <b-col v-html="item.text" class="text-center p-4">
                                       </b-col>
                                    </b-row>
                                 </div>
                                 <div class="about-box"
                                      v-else-if="item.template === 'Horizontal Bild und Text'">
                                    <b-row no-gutters>
                                       <b-col sm="12" md="6" v-if="item.image">
                                          <img :src="fileResourceUrl(item.image)"
                                               :alt="item.image"/>
                                       </b-col>
                                       <b-col sm="12" md="6" v-html="item.text" class="text-center p-4">
                                       </b-col>
                                    </b-row>
                                 </div>
                              </div>
                           </b-col>
                        </b-row>
                     </b-col>
                  </b-row>
               </b-container>
            </template>
         </pb-body>
      </template>
   </pb-body-base>
</template>


<script>

import ContentAPI from "@shared/_api/cms/content";
import {store} from "@client/src/_store";

export default {
   name: 'content-grid',
   data: function () {
      return {
         breadcrumbs: [{
            text: "Sustainability",
            href: '/sustainability'
         }],
         layout: [],
         bannerImage: "",
         busy: false,
      }
   },
   methods: {
      initList: function (listName) {
         this.busy = true;
         const currentUser = store.state.account.user;
         ContentAPI.fetchListByName(listName).then(result => {
            this.layout = result.filter(item => {
               const hideForGuests = item.hideForGuests && item.hideForGuests.value;
               const hideForUsers = item.hideForUsers && item.hideForUsers.value;

               // Filter logic
               if (hideForGuests && !currentUser) {
                  // Hide item for guests (not logged in)
                  return false;
               }
               if (hideForUsers && currentUser) {
                  // Hide item for logged-in users
                  return false;
               }
               return true;
            }).map(item => {
               return {
                  width: parseInt(item.width.value),
                  image: item.image.value,
                  headline: item.headline.value,
                  text: item.text.value,
                  template: item.template.value,
                  order: parseInt(item.order.value),
                  disableForGuests: item.disableForGuests && item.disableForGuests.value && !currentUser
               }
            });
            this.layout = this.$_.orderBy(this.layout, ['order'], ['asc']);
         }).finally(() => {
            this.busy = false
         });
      },
   },
   beforeRouteUpdate(to, from, next) {
      this.initList(to.params.listName);
      next();
   },
   created() {
      this.initList(this.$route.params.listName);
   }
}
</script>

<style lang="scss" scoped>

@import "~@shared/_assets/scss/constants";

.vue-grid-item.no-touch {
   touch-action: auto;
}

.vue-grid-item {
   padding: 10px;


}

.about-box {
   height: 100%;
   width: 100%;
   background: #F1F1F1;

   img {
      object-fit: cover;
      width: 100%;
      height: 100%;
   }


}

.disabled-column {
   position: relative;
   pointer-events: none;

   .content-wrapper {
      opacity: 0.5;
   }

   .disabled-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.2);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 10;

      span {
         background-color: rgba(255, 255, 255, 0.8);
         padding: 10px;
         border-radius: 5px;
         font-weight: bold;
      }
   }
}
</style>
